module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/2@2x_a3590b925aef48e0c7a9731237ad99e6.png";